/**
 * BelgeYukleModal.jsx — denetmenin bir kişinin TEK belge türüne dosya yüklediği küçük pencere (backlog #279).
 *
 * Kişi detayındaki her belge kutusunda (onaylı olanlar dahil — basılmış bir kart yüklemeyi hiç durdurmaz)
 * "Yükle" / "Yeniden Yükle" bunu açar. SGK / İSG iki varyantlı olduğu için BelgeVaryantModal'dan, KVKK kendi
 * ucundan (Detaylar sekmesindeki düğme) yüklenir; bu pencere kalan türler (Sağlık, Mesleki Eğitim, Yüksekte
 * Çalışma, Aşı Kartı, Kimlik Fotoğrafı, meslek kuralının eklediği `fileType{id}`) için.
 *
 * POST /personnel/dosyaekle/{personId}. Yeni dosya onaylı ve süresi dolmamış bir belgenin yerini ALMAZ
 * (backend onaylı olanı öne alır); son kullanma tarihi boş bırakılırsa backend bugün + 60 gün yazar.
 */
import React, { useState } from "react";
import { Alert, Button, Label, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from "reactstrap";
import { dosyaHatasi, uploadKisiBelgesi } from "../../services/personelBelgeService";
import TarihGirdisi from "../Common/TarihGirdisi";
import { DosyaKaynakDugmeleri } from "../Common/DosyaKaynakSecici";
import { useTranslation } from "react-i18next";

const bugun = () => new Date().toISOString().slice(0, 10);

// `meslekId` (#372): yalnızca Mesleki Eğitim yüklemesinde — sertifikayı o mesleğe etiketler (kişi 2+ meslek taşıyorsa etiketsiz
// sertifika hiçbirine sayılmaz). Diğer belge türlerinde verilmez.
export default function BelgeYukleModal({ personId, personAd, belgeAdi, fileTypeId, fuarId, meslekId, onClose, onDone }) {
  const { t } = useTranslation("components");
  const [file, setFile] = useState(null);
  const [bitis, setBitis] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const dosyaSorunu = file ? dosyaHatasi(file) : null;

  async function yukle() {
    setBusy(true);
    setError(null);
    try {
      await uploadKisiBelgesi(personId, fileTypeId, file, { fuarId, expiryDate: bitis || undefined, meslekId });
      onDone(t("belgeYukleModal.yuklendi", { belgeAdi }));
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Modal isOpen toggle={busy ? undefined : onClose} centered>
      <ModalHeader toggle={busy ? undefined : onClose}>{belgeAdi}{" "}{t("belgeYukleModal.yukle")}{" "}{personAd}</ModalHeader>
      <ModalBody>
        {error && <Alert fade={false} color="danger" className="py-2 small">{error}</Alert>}
        {/* #727: "Fotoğraf çek" / "Dosyadan yükle" — WAS: <Input type="file" bsSize="sm" accept=".pdf,.jpg,.jpeg,.png" invalid={!!dosyaSorunu} onChange={(e) => setFile(e.target.files?.[0] ?? null)} /> */}
        <DosyaKaynakDugmeleri accept=".pdf,.jpg,.jpeg,.png" onDosya={setFile} disabled={busy} />
        <div className={`small mt-2 ${file ? "" : "text-muted"}`} data-testid="belge-yukle-secilen">{file ? file.name : t("common:dosyaKaynagi.dosyaSecilmedi")}</div>
        {dosyaSorunu && <div className="small text-danger mt-1">{dosyaSorunu}</div>}
        <Label className="small mt-3 mb-1">{t("belgeYukleModal.sonKullanmaTarihiIstegeBagli")}</Label>
        <TarihGirdisi min={bugun()} value={bitis} onChange={setBitis} />
      </ModalBody>
      <ModalFooter>
        <Button color="light" onClick={onClose} disabled={busy}>{t("belgeYukleModal.vazgec")}</Button>
        <Button color="primary" onClick={yukle} disabled={busy || !file || !!dosyaSorunu}>
          {busy ? <Spinner size="sm" /> : t("common:yukle")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
